/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class DimensionMembershipKeyValuePair {
    getFixupPrototypeFunction() { return DimensionMembershipKeyValuePair.fixupPrototype; }

    static newInstance(model: Partial<DimensionMembershipKeyValuePair>): DimensionMembershipKeyValuePair {
        let obj = Object.assign(new DimensionMembershipKeyValuePair(), model);
        DimensionMembershipKeyValuePair.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<DimensionMembershipKeyValuePair>): DimensionMembershipKeyValuePair {
        if (!model) return null;
        return DimensionMembershipKeyValuePair.newInstance(<DimensionMembershipKeyValuePair> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: DimensionMembershipKeyValuePair) {
        if (!obj) return;

        models.DimensionMembershipKeyValuePair.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: DimensionMembershipKeyValuePair): boolean {
        Object.setPrototypeOf(obj, DimensionMembershipKeyValuePair.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Dimension ID
     */
    dimension_id: string;

    /**
     * Grouping Rule ID
     */
    grouping_rule_id: string;

}
